import React, { useEffect, useState } from "react";
import { Box, Tooltip } from "@mui/material";
import './DateSlider.css';

const DoubleDateSlider = ({
    sameTopic=false,
    topicOne,
    topicTwo, onThumbChange, axisVal1 = 1, axisVal2 = 286, minVal1 = 1, maxVal1 = 252, minVal2 = 260, maxVal2 = 286, sliderStartDate = "2024, 6, 13" }) => {

    // Create 10 evenly spaced points between min and max
    const points = Array.from({ length: 10 }, (_, index) => Math.round((index / 9) * (axisVal2 - axisVal1) + axisVal1));

    // const baseDate = new Date(sliderStartDate); // July 13, 2024
    const [year, month, day] = sliderStartDate?.split(',').map(str => parseInt(str.trim()));
    const baseDate = new Date(year, month, day);
    const formatDate = (date) => {
        if (date) {

            const d = new Date(date); // ensure it's a Date object
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } else {
            return;
        }
    };


    const dateFromDay = (dayNum) => {
        const result = new Date(baseDate);
        result.setDate(result.getDate() + (dayNum - 1));
        return result.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const [leftThumb1, setLeftThumb1] = useState(minVal1);
    const [rightThumb1, setRightThumb1] = useState(maxVal1);
    const [leftThumb2, setLeftThumb2] = useState(minVal2);
    const [rightThumb2, setRightThumb2] = useState(maxVal2);

    const percentFromValue = (val) => ((val - axisVal1) / (axisVal2 - axisVal1)) * 100;




    const handleMove = (clientX, container, track, thumbType) => {
        const rect = container.getBoundingClientRect();
        const relativeX = clientX - rect.left;
        const percent = relativeX / rect.width;
        const newValue = Math.round(percent * (axisVal2 - axisVal1) + axisVal1);
        if (topicOne?.start_date == topicOne?.end_date) {

        } else {
            if (track === 1) {
                if (thumbType === "left") {
                    const clamped = Math.min(Math.max(newValue, minVal1), rightThumb1 - 1, maxVal1);
                    setLeftThumb1(clamped);
                }
                if (thumbType === "right") {
                    if (sameTopic == true) {
                        const clamped = Math.max(Math.min(newValue, leftThumb2), leftThumb1 + 1, minVal1);
                        setRightThumb1(clamped);
                    } else {
                        const clamped = Math.max(Math.min(newValue, maxVal1), leftThumb1 + 1, minVal1);
                        setRightThumb1(clamped);
                    }
                }
            }
        }
        if (topicTwo?.start_date == topicTwo?.end_date) {

        } else {

            if (track === 2) {
                if (thumbType === "left") {
                    if (sameTopic == true) {

                        const clamped = Math.min(Math.max(newValue, rightThumb1), rightThumb2 - 1, maxVal2);
                        setLeftThumb2(clamped);
                    } else {
                        const clamped = Math.min(Math.max(newValue, minVal2), rightThumb2 - 1, maxVal2);
                        setLeftThumb2(clamped);
                    }

                }
                if (thumbType === "right") {
                    const clamped = Math.max(Math.min(newValue, maxVal2), leftThumb2 + 1, minVal2);
                    setRightThumb2(clamped);
                }
            }
        }

    };

    const setupThumbDrag = (e, track, thumbType) => {
        const container = e.currentTarget.parentNode;
        const move = (ev) => handleMove(ev.clientX, container, track, thumbType);
        const stop = () => {
            document.removeEventListener("mousemove", move);
            document.removeEventListener("mouseup", stop);
        };
        document.addEventListener("mousemove", move);
        document.addEventListener("mouseup", stop);
        handleMove(e.clientX, container, track, thumbType);
    };

    useEffect(() => {
        setLeftThumb1(minVal1)
        setRightThumb1(maxVal1)
        setLeftThumb2(minVal2)
        setRightThumb2(maxVal2)


    }, [minVal1, maxVal1, minVal2, maxVal2]);

    useEffect(() => {
        onThumbChange({
            track1: {
                start: formatDate(dateFromDay(leftThumb1)),
                end: formatDate(dateFromDay(rightThumb1)),
            },
            track2: {
                start: formatDate(dateFromDay(leftThumb2)),
                end: formatDate(dateFromDay(rightThumb2)),
            }
        });
    }, [leftThumb1, rightThumb1, leftThumb2, rightThumb2]);


    return (
        <div style={{ borderRadius: '4px', border: '1px solid rgb(162, 162, 162)', marginTop: '20px' }}>

            <Box sx={{ width: "90%", padding: "20px", marginLeft: 'auto', marginRight: 'auto' }}>
                <Box className="sliderContainer" sx={{ position: "relative", height: "60px" }}>
                    <span className="sliderrail"></span>

                    {/* Track 1 */}
                    <span
                        className="slidertrack"
                        style={{
                            left: `${percentFromValue(leftThumb1)}%`,
                            width: `${percentFromValue(rightThumb1) - percentFromValue(leftThumb1)}%`,
                            backgroundColor: "rgba(23, 120, 102, 1)",
                        }}
                    ></span>

                    {/* Track 2 */}
                    <span
                        className="slidertrack"
                        style={{
                            left: `${percentFromValue(leftThumb2)}%`,
                            width: `${percentFromValue(rightThumb2) - percentFromValue(leftThumb2)}%`,
                            backgroundColor: "rgba(88, 167, 68, 1)",
                        }}
                    ></span>

                    {/* Labels with tooltip as full date */}
                    <Box className="sliderLabels">
                        {points.map((val) => (
                            <Box
                                key={val}
                                className="sliderLabel"
                                sx={{
                                    position: "absolute",
                                    left: `${percentFromValue(val)}%`,
                                    bottom: "-10px",
                                    transform: "translateX(-50%)",
                                    fontSize: "10px",
                                    fontWeight: 400,
                                    color: 'rgba(99, 99, 99, 1)',
                                    fontFamily: 'Inter'
                                }}
                            >
                                <Tooltip title={dateFromDay(val)} arrow>
                                    <span style={{ minWidth: '61px', display: 'flex' }}>{dateFromDay(val)}</span>
                                </Tooltip>
                            </Box>
                        ))}
                    </Box >

                    {/* Thumbs for Track 1 */}
                    < span
                        className="sliderThumb"
                        style={{ left: `${percentFromValue(leftThumb1)}% ` }}
                        onMouseDown={(e) => setupThumbDrag(e, 1, "left")}
                    >
                        <span className="sliderValueLabel">
                            <span className="sliderValueLabelCircle">{dateFromDay(leftThumb1)}</span>
                        </span>
                    </span >
                    <span
                        className="sliderThumb"
                        style={{ left: `${percentFromValue(rightThumb1)}%` }}
                        onMouseDown={(e) => setupThumbDrag(e, 1, "right")}
                    >
                        <span className="sliderValueLabel">
                            <span className="sliderValueLabelCircle">{dateFromDay(rightThumb1)}</span>
                        </span>
                    </span >

                    {/* Thumbs for Track 2 */}
                    < span
                        className="sliderThumb"
                        style={{ left: `${percentFromValue(leftThumb2)}% ` }}
                        onMouseDown={(e) => setupThumbDrag(e, 2, "left")}
                    >
                        <span className="sliderValueLabel">
                            <span className="sliderValueLabelCircle">{dateFromDay(leftThumb2)}</span>
                        </span>
                    </span >
                    <span
                        className="sliderThumb"
                        style={{ left: `${percentFromValue(rightThumb2)}%` }}
                        onMouseDown={(e) => setupThumbDrag(e, 2, "right")}
                    >
                        <span className="sliderValueLabel">
                            <span className="sliderValueLabelCircle">{dateFromDay(rightThumb2)}</span>
                        </span>
                    </span >
                </Box >
            </Box >
        </div>
    );
};

export default DoubleDateSlider;